import React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TurmaDisciplinaProfessorProfileInfo from './TurmaDisciplinaProfessorProfileInfo';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '100%',
    },
    title: {
        fontSize: 25,
    },
    pos: {
        marginBottom: 12,
    },
});

export default function TurmaDisciplinaProfessorProfileWithoutChange({ tdp }) {
    const classes = useStyles();


    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <TurmaDisciplinaProfessorProfileInfo
                    tdp={tdp} />

            </CardContent>
        </Card>
    );
}